export const LOCAL_STORAGE_KEYS = {
  cartId9: 'cartId9',
  cart: 'cart',
  mysteryCollectionPreference: 'mysteryCollectionPreference',
  password: 'password',
  newsletterSubscribed: 'newsletter_subscribed',
  // Klaviyo's anonymous-activity backfill buffer. Written by klaviyo.js, not by us,
  // but registered here so the cookie policy and the consent-withdrawal purge refer
  // to one definition rather than three string literals.
  klaviyoActivityBuffer: 'kl-post-identification-sync',
} as const;

export const COOKIE_NAMES = {
  cookieConsent: 'cookie_consent',
  signupModalDismissed: 'signup_modal_dismissed',
  region: 'bp_region',
  countryCode: 'bp_country_code',
  // Set by klaviyo.js. Registered for the same reason as the buffer above: the
  // cookie-policy tables in constants/cookie/ disclose these by name, and a rename
  // that misses one turns a legal disclosure into a lie with nothing to catch it.
  klaviyoId: '__kla_id',
} as const;

export const SESSION_STORAGE_KEYS = {
  region: COOKIE_NAMES.region,
  countryCode: COOKIE_NAMES.countryCode,
  // Klaviyo's email-click exchange id. Session storage, NOT a cookie — it is
  // disclosed under the browser-storage section of the cookie policy, not in the
  // cookie tables.
  klaviyoExchangeId: '_kx',
} as const;
